document.addEventListener("DOMContentLoaded", function () {
  const dateInput = document.getElementById("preferred-delivery-date");
  if (!dateInput) return;

  // ===== DELIVERY RULE CONFIG =====
  const deliveryRules = {
    1: 2, // Monday → earliest Wednesday
    2: 2, // Tuesday → earliest Thursday
    3: 2, // Wednesday → earliest Friday
    4: 2, // Thursday → earliest Saturday
    5: 3, // Friday → earliest Monday
    6: 2, // Saturday → earliest Monday
    0: 2  // Sunday → earliest Tuesday
  };

  const cutoffHour = 12; // 12pm cutoff

  // ===== HELPER: FORMAT DATE AS UK (DD/MM/YYYY) =====
  function formatUK(dateStr) {
    const parts = dateStr.split("-");
    return `${parts[2]}/${parts[1]}/${parts[0]}`;
  }

  // ===== CALCULATE EARLIEST DELIVERY DATE =====
  function calculateEarliestDelivery() {
    const now = new Date();
    let earliest = new Date();

    const day = now.getDay();
    let minOffset = deliveryRules[day] || 2;

    if (now.getHours() >= cutoffHour) {
      const nextDay = (day + 1) % 7;
      minOffset = deliveryRules[nextDay] || minOffset;
    }

    earliest.setDate(earliest.getDate() + minOffset);

    const yyyy = earliest.getFullYear();
    const mm = String(earliest.getMonth() + 1).padStart(2, '0');
    const dd = String(earliest.getDate()).padStart(2, '0');

    return `${yyyy}-${mm}-${dd}`;
  }

  const earliestAllowedDate = calculateEarliestDelivery();
  dateInput.setAttribute("min", earliestAllowedDate);

  // ===== VALIDATION HANDLER =====
  function validateDateInput() {
    const value = dateInput.value;
    const errorId = "delivery-date-error";
    let errorEl = document.getElementById(errorId);

    if (!errorEl) {
      errorEl = document.createElement("div");
      errorEl.id = errorId;
      errorEl.style.color = "red";
      errorEl.style.marginTop = "4px";
      dateInput.insertAdjacentElement("afterend", errorEl);
    }

    if (!value) {
      errorEl.textContent = "Please enter a delivery date.";
      return false;
    }

    if (value < earliestAllowedDate) {
      errorEl.textContent = `The earliest available delivery date is ${formatUK(earliestAllowedDate)}.`;
      return false;
    }

    errorEl.textContent = "";
    return true;
  }

  dateInput.addEventListener("change", validateDateInput);

  // ===== BLOCK ADD TO CART IF INVALID =====
  const addToCartBtn = document.querySelector("button[name='add']");
  if (addToCartBtn) {
    addToCartBtn.addEventListener("click", function (event) {
      if (!validateDateInput()) {
        event.preventDefault();
        event.stopPropagation();
      }
    });
  }
});
